import { getUndefinedParametersIndexes, markParamaterRequired } from '../apiTransformers/transformers';
import { LOG_TYPE } from '../const';
import { logger } from '../logger/logger.class';
/**
 * markAsRequired - mark a method's parameter as required
 * Note: This decorator needs to be used with `ValidateRequiredParameters` method decorator for the logic to work
 *
 * @param parameterIndex
 *
  ```
  import { getUndefinedRequiredParametersIndexes, markParamaterRequired } from '../apiTransformers/transformers';
  import { LOG_TYPE } from '../const';
  import { logger } from '../logger/logger.class';
  import { Dictionary, FunctionLike } from '../model/globals.model';

  @ValidateRequiredParameters
  myMethod(@markAsRequired requiredParameter) {}
  ```
 */
export function markAsRequired(target, propertyKey, parameterIndex) {
    markParamaterRequired(target, propertyKey, parameterIndex);
}
/**
 * ValidateRequiredParameters - validates if all parameters marked as required are present
 *
 *
 * @returns function
  ```
  import { getUndefinedRequiredParametersIndexes, markParamaterRequired } from '../apiTransformers/transformers';
  import { LOG_TYPE } from '../const';
  import { logger } from '../logger/logger.class';
  import { Dictionary, FunctionLike } from '../model/globals.model';

  @ValidateRequiredParameters
  myMethod(@markAsRequired requiredParameter) {}
  ```
 */
export function ValidateRequiredParameters() {
    return function (target, propertyKey, descriptor) {
        const method = descriptor.value;
        descriptor.value = function (...args) {
            const undefinedRequiredParametersIndexes = getUndefinedParametersIndexes(target, propertyKey, args);
            if (undefinedRequiredParametersIndexes.length) {
                logger.message(`Required parameters at positions ${undefinedRequiredParametersIndexes} are undefined. Skipping function execution`, LOG_TYPE.error);
                return;
            }
            return method === null || method === void 0 ? void 0 : method.apply(this, args);
        };
    };
}
